import { status } from 'constants/general';
import { initialAccountManagementState } from 'redux/initialStates';
import accountManagementActionTypes from './action-types';

const ordersReducer = (state = initialAccountManagementState, { type, payload }) => {
  switch (type) {
    case accountManagementActionTypes.FETCH_USER_AUTHENTICATION_INFO:
      return {
        ...state,
        userAuthenticationInfo: {
          status: status.FETCHING,
        },
      };

    case accountManagementActionTypes.FETCH_USER_AUTHENTICATION_INFO_SUCCESS:
      return {
        ...state,
        userAuthenticationInfo: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case accountManagementActionTypes.FETCH_USER_AUTHENTICATION_INFO_FAIL:
      return {
        ...state,
        userAuthenticationInfo: {
          status: status.FAIL,
        },
      };

    case accountManagementActionTypes.FETCH_LOGIN_INFO:
      return {
        ...state,
        loginInfo: {
          status: status.FETCHING,
        },
      };

    case accountManagementActionTypes.FETCH_LOGIN_INFO_SUCCESS:
      return {
        ...state,
        loginInfo: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case accountManagementActionTypes.FETCH_LOGIN_INFO_FAIL:
      return {
        ...state,
        loginInfo: {
          status: status.FAIL,
        },
      };

    default:
      return state;
  }
};

export default ordersReducer;
